import {SET_PLANNING_SEARCH_DATE} from '../constants/ActionTypes'

const initialState = {
    startDate : "",
    endDate: ""
};

export default function orderHist(state = initialState, action) {
    switch (action.type) {
        case SET_PLANNING_SEARCH_DATE:
            if(state.startDate !== action.startDate || state.endDate !== action.endDate) {
                return Object.assign({}, state, {startDate: action.startDate, endDate: action.endDate});
            }
            return state;
        default:
            return state;
    }
}